export default {
    create: function() {
        let publicAPIs = {}

        let _event = {}

        // publicAPIs.getSomeValue = function() {
        //     return _value
        // }
    
        publicAPIs.listenToEvent = function(key, action) {
            if( _event.hasOwnProperty(key) ) {
                _event[ key ].push(action)
            } else {
                _event[ key ] = [ action ]
            }
        }

        publicAPIs.fireEvent = function(key, payload) {
            if( !_event.hasOwnProperty(key) )
                return

            _event[ key ].forEach( action => {            
                action(payload)
            })
        }

        // publicAPIs.preloadAssets = function(game, scene) {
        // }

        // publicAPIs.beforeInitialized = function(game, scene) {
        // }

        // publicAPIs.initialize = function(game, scene) {
        // }

        // publicAPIs.didInitialized = function(game, scene) {
        // }

        // publicAPIs.update = function(time, delta, game, scene) {
        // }

        return publicAPIs
    },
}